export const spaceOnNumbers=(nb)=> {
  if (isNaN(nb))
    return '';
    
  return nb?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}